
import {useEffect, useState} from "react";
import axios from "axios";
import {API_BASE} from "../utils/api";
import {getMedianOfTopPercent} from "../utils/utils";
import {
    CALCULATED_FUNCTIONS,
    GEOTHERMAL_PERCENT,
    GEOTHERMAL_PRODUCTION_CONST,
    GEOTHERMAL_WELLS_DEFAULT,
    TCalculatedFunction
} from "../utils/consts";
import {DataPoint} from "../component/Scatterplot";
import {IChemicalRow} from "./usePDOilfield";

export interface IRow {
    cl: number;
    ce: number;
}

export type TChemical = IChemicalRow[];
export type TData = IRow[];

export const usePDGeothermal = () => {
    const [data, setData] = useState<{data: TData, chemical: TChemical}>({data: [], chemical: []});
    const [calculatedData, setCalculatedData] = useState<DataPoint[]| undefined>(undefined);
    const [wellsAmount, setWellsAmount] = useState<number>(GEOTHERMAL_WELLS_DEFAULT);
    const [geothermalPercent, setGeothermalPercent] = useState<number>(GEOTHERMAL_PERCENT * 100);
    const [calculatedFunction, setCalculatedFunction] = useState<TCalculatedFunction>(CALCULATED_FUNCTIONS[0]);
    const [loading, setLoading] = useState(true);

    const fetchData = async (country?: string) => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE}/concentration/geothermal${country ? `?country=${country}` : ''}`, {
                headers: {
                    'content-type': 'application/json',
                }
            });
            setData({data: response.data.data, chemical: response.data.chemical});
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (geothermalPercent  && geothermalPercent > 0) {
            const calculatedData = getMedianOfTopPercent(
              data!.data,
              data!.chemical,
              geothermalPercent / 100,
              GEOTHERMAL_PRODUCTION_CONST,
              wellsAmount,
              calculatedFunction,
            );
            setCalculatedData(calculatedData);
        }

    }, [data, wellsAmount, geothermalPercent, calculatedFunction])

    return {
        data,
        calculatedData,
        loading,
        wellsAmount,
        geothermalPercent,
        setGeothermalPercent,
        setData,
        fetchData,
        setWellsAmount,
        calculatedFunction,
        setCalculatedFunction
    };
}